const W = 1080;
const H = 1350;

function wrap(ctx, text, maxW, maxLines) {
  const words = text.replace(/\s+/g, " ").trim().split(" ");
  const lines = [];
  let line = "";
  for (const w of words) {
    const t = line ? `${line} ${w}` : w;
    if (ctx.measureText(t).width > maxW && line) {
      lines.push(line);
      line = w;
      if (lines.length === maxLines) break;
    } else line = t;
  }
  if (lines.length < maxLines && line) lines.push(line);
  if (lines.length === maxLines && words.join(" ").length > lines.join(" ").length) lines[maxLines - 1] = lines[maxLines - 1].replace(/\s*\S*$/, "") + "…";
  return lines;
}

function diya(ctx, x, y, s) {
  const g = ctx.createRadialGradient(x, y - 40 * s, 4, x, y - 40 * s, 90 * s);
  g.addColorStop(0, "rgba(255,214,102,0.9)");
  g.addColorStop(1, "rgba(255,159,10,0)");
  ctx.fillStyle = g;
  ctx.beginPath(); ctx.arc(x, y - 40 * s, 90 * s, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = "#FFD166";
  ctx.beginPath(); ctx.moveTo(x, y - 78 * s);
  ctx.quadraticCurveTo(x + 18 * s, y - 40 * s, x, y - 22 * s);
  ctx.quadraticCurveTo(x - 18 * s, y - 40 * s, x, y - 78 * s); ctx.fill();
  ctx.fillStyle = "#C2410C";
  ctx.beginPath(); ctx.ellipse(x, y, 62 * s, 26 * s, 0, 0, Math.PI); ctx.fill();
  ctx.fillStyle = "#EA580C";
  ctx.beginPath(); ctx.ellipse(x, y, 62 * s, 10 * s, 0, 0, Math.PI * 2); ctx.fill();
}

function rangoli(ctx, cx, cy, r) {
  const colors = ["#FF2D55", "#FF9F0A", "#FFD166", "#32ADE6", "#AF52DE"];
  for (let ring = 0; ring < 5; ring++) {
    const n = 8 + ring * 4;
    for (let i = 0; i < n; i++) {
      const a = (i / n) * Math.PI * 2;
      ctx.fillStyle = colors[(i + ring) % colors.length];
      ctx.globalAlpha = 0.5;
      ctx.beginPath();
      ctx.ellipse(cx + Math.cos(a) * r * (ring + 1) * 0.2, cy + Math.sin(a) * r * (ring + 1) * 0.2, 14, 6, a, 0, Math.PI * 2);
      ctx.fill();
    }
  }
  ctx.globalAlpha = 1;
}

export async function renderShareCard({ title, prompt, category, link }) {
  if (document.fonts?.ready) await document.fonts.ready;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  const bg = ctx.createLinearGradient(0, 0, W, H);
  bg.addColorStop(0, "#3B0A1E"); bg.addColorStop(0.55, "#7A1E1E"); bg.addColorStop(1, "#C2410C");
  ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
  rangoli(ctx, W - 120, 140, 300);
  rangoli(ctx, 110, H - 330, 220);
  for (let i = 0; i < 60; i++) {
    ctx.fillStyle = `rgba(255,214,102,${Math.random() * 0.5})`;
    ctx.beginPath(); ctx.arc(Math.random() * W, Math.random() * H * 0.6, Math.random() * 3 + 1, 0, Math.PI * 2); ctx.fill();
  }

  const pill = category && category !== "Diwali" ? `Diwali Prompt · ${category}` : "Diwali Prompt";
  ctx.font = "600 28px Outfit, sans-serif";
  const pw = ctx.measureText(pill).width + 56;
  ctx.fillStyle = "rgba(255,255,255,0.14)";
  ctx.beginPath(); ctx.roundRect(80, 120, pw, 60, 30); ctx.fill();
  ctx.fillStyle = "#FFD166";
  ctx.fillText(pill, 108, 160);

  ctx.fillStyle = "#FFFFFF"; ctx.font = "700 76px Outfit, sans-serif";
  const tl = wrap(ctx, title, W - 160, 3);
  tl.forEach((l, i) => ctx.fillText(l, 80, 300 + i * 88));

  const boxY = 300 + tl.length * 88 + 30;
  ctx.fillStyle = "rgba(0,0,0,0.28)";
  ctx.beginPath(); ctx.roundRect(80, boxY, W - 160, 400, 36); ctx.fill();
  ctx.fillStyle = "rgba(255,255,255,0.88)"; ctx.font = "400 32px 'JetBrains Mono', monospace";
  wrap(ctx, prompt, W - 240, 8).forEach((l, i) => ctx.fillText(l, 120, boxY + 70 + i * 44));

  diya(ctx, W / 2 - 170, H - 300, 1); diya(ctx, W / 2, H - 285, 1.3); diya(ctx, W / 2 + 170, H - 300, 1);

  ctx.textAlign = "center";
  ctx.fillStyle = "#FFFFFF"; ctx.font = "700 46px Outfit, sans-serif";
  ctx.fillText("Get 12 free Diwali prompts", W / 2, H - 150);
  const shown = link.replace(/^https?:\/\//, "");
  let fs = 30;
  do { ctx.font = `500 ${fs}px Inter, sans-serif`; fs -= 1; } while (ctx.measureText(shown).width > W - 120 && fs > 14);
  ctx.fillStyle = "#FFD166";
  ctx.fillText(shown, W / 2, H - 100);
  ctx.fillStyle = "rgba(255,255,255,0.7)"; ctx.font = "600 26px Outfit, sans-serif";
  ctx.fillText("SpeakToPrompt · Say it. Get the perfect prompt.", W / 2, H - 52);

  return new Promise((resolve) => c.toBlob((b) => resolve({ blob: b, url: c.toDataURL("image/png") }), "image/png"));
}
